import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Button, Divider, Container } from 'semantic-ui-react';

import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';

import InfluencerIcon from '../../components/influencer-icon';
import TargetLink from '../../components/target-link';
import ThemeSelector from '../../themes/theme-selector';

export default class InfluencerContextBar extends Component {
  static propTypes = {
    organisationName: PropTypes.string,
    showTooltip: PropTypes.bool,
    hasCTA: PropTypes.bool,
    cta: PropTypes.node,
    title: PropTypes.string.isRequired,
    leftButtonCallback: PropTypes.func,
    rightButtonCallback: PropTypes.func.isRequired,
    leftButtonLabel: PropTypes.string,
    rightButtonLabel: PropTypes.string.isRequired,
    hasPrivateLink: PropTypes.bool,
  };

  static defaultProps = {
    hasCTA: false,
    showTooltip: false,
    cta: <div />,
    hasPrivateLink: false,
    leftButtonCallback: null,
    leftButtonLabel: null,
  };

  static defaultProps = {
    organisationName: '',
  };

  constructor() {
    super();
    this.state = {
      popupOpen: false,
      modalOpen: false,
    };
  }

  onPrivateLinkClick = () => {
    const { modalOpen } = this.state;
    this.setState({
      modalOpen: !modalOpen,
    });
  }

  render() {
    const {
      leftButtonCallback,
      rightButtonCallback,
      leftButtonLabel,
      rightButtonLabel,
      organisationName,
      hasCTA,
      hasPrivateLink,
      cta,
      title,
      onBackClick,
    } = this.props;

    const boxStyle = {
      paddingTop: 19,
      paddingBottom: 19,
    };
    const { disableHelpLinks } = ThemeSelector.theme();

    const { modalOpen } = this.state;

    if (organisationName) {
      return (
        <div className="influencer-context-bar" style={boxStyle}>
          { hasCTA &&
          <div className="flex">
            <div className="space" />
            <div className="item">
              {cta}
            </div>
          </div> }
          <div className="spacer small" />
          <div className="flex">
            <div className="item">
              <h1>{title}</h1>
            </div>
            <div className="space" />
          </div>
          <div className="flex">
            <div className="item">
              <h3 className="light">{ organisationName || '' }</h3>
            </div>
            <div className="item">
              <div className="horizontal-spacer" />
            </div>
            { hasPrivateLink &&
              <div className="item">
                <p>
                  <a onClick={this.onPrivateLinkClick}>
                    <img className="inline" src="/icons/padlock.svg" alt="private" />&nbsp;&nbsp;Private
                  </a>
                </p>
              </div>
            }
            <div className="space" />
            { leftButtonCallback && <div className="item">
              <Button
                basic
                onClick={leftButtonCallback}
                size="medium"
              >
                {leftButtonLabel}
              </Button>
            </div>
            }
            <div className="item">
              <div className="horizontal-spacer" />
            </div>
            { rightButtonCallback && <div className="item" onMouseOver={() => this.setState({ popupOpen: true })}>
              <div className="dropdown open-left">
                <span className="dropdown-selector">
                  <Button
                    color="pink"
                    size="medium"
                    onClick={rightButtonCallback}
                  >
                    {rightButtonLabel}
                  </Button>
                </span>
                <div className={`dropdown-area ${this.props.showTooltip && 'visible'}`}>
                  <div className="arrow" />
                  <div className="wrapper">
                    <div className="dropdown-content">
                      <ul>
                        <li className="no-effect"><p>add an influencer to get started</p></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div> }
          </div>
          {
            modalOpen &&
            <DyzioModal
              headerText="Your Private Database"
              onClose={this.onPrivateLinkClick}
              size="tiny"
            >
              <InfluencerIcon centered />
              <Divider />
              <Container textAlign="center">
                <p>
                  {`Your "My Influencers" database is private.
                  Your influencers are never shared with other companies and the influencers are not notified
                  when you add them to the database.`}
                </p>
                <br />
                <p>
                  {!disableHelpLinks && <TargetLink
                    renderIf
                    href="https://help.dyzio.co/my-influencers-database/dyzio-private-database"
                  >
                    <span>&nbsp;Read more</span>
                  </TargetLink>}
                </p>
              </Container>
            </DyzioModal>
          }
        </div>
      );
    }

    return (
      <div className="page-hero flex small">
        <div className="item">
          <h3>
            <a style={{ cursor: 'pointer' }} onClick={onBackClick || browserHistory.goBack}>
              <img src="/icons/chevron-left.svg" alt="back" /> {title}
            </a>
          </h3>
        </div>
        <div className="space" />
        { leftButtonCallback && <div className="item">
          <Button
            basic
            onClick={leftButtonCallback}
            size="medium"
          >
            {leftButtonLabel}
          </Button>
        </div>
        }
        <div className="item">
          <div className="horizontal-spacer" />
        </div>
        <div className="item">
          <Button
            color="pink"
            size="medium"
            onClick={rightButtonCallback}
          >
            {rightButtonLabel}
          </Button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/influencer-context-bar/index.js
 **/